export default "__VITE_ASSET__D2_o1n6___"